/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * document_storage_service
 * OpenAPI spec version: 0.1.0
 */

/**
 * Aggregate ingestion state across every calendar account visible to a
requester, letting clients render progressively while sources build.
 */
export type CalendarSyncStatus =
  (typeof CalendarSyncStatus)[keyof typeof CalendarSyncStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CalendarSyncStatus = {
  syncing: 'syncing',
  ready: 'ready',
} as const;
